/*
Documentation

There are no onload events for this plugin

*/

export default [

]